export default "__VITE_ASSET__CYX5fend__"